import React, { useState, useEffect, Fragment } from "react";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import "./index.scss";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { useGetProductQuery } from "../../services/product";
import { useGetRelatedQuery } from "../../services/homepage";
import ProductImages from "../../Components/ProductImages";
import ProductDetails from "../../Components/ProductDetails";
import ProductFeatures from "../../Components/ProductFeatures";
import AddToCart from "../../Components/AddToCart";
import { useMediaQuery } from "react-responsive";
import Button from "@mui/material/Button";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { addLocalProducts } from "../../Reducers/authReducer";
import ViewedProducts from "../../Components/ViewedProducts";
import { Helmet } from "react-helmet-async";
import Host from "../../Components/Host";
import { notification } from "antd";
import "antd/dist/antd.min.css";
import { emphasize, styled } from "@mui/material/styles";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Chip from "@mui/material/Chip";
import HomeIcon from "@mui/icons-material/Home";
import HomeProductCards from "../../Components/HomeProductCards";

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  return {
    backgroundColor: theme.palette.grey[100],
    height: theme.spacing(3),
    fontSize: "0.75rem",
    borderRadius: "10px",
    color: (theme.vars || theme).palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    "&:hover, &:focus": {
      backgroundColor: emphasize(theme.palette.grey[100], 0.06),
    },
    "&:active": {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(theme.palette.grey[100], 0.12),
    },
    ...theme.applyStyles("dark", {
      backgroundColor: theme.palette.grey[800],
    }),
  };
});

const storIds = [1, 3, 18, 19, 20, 21, 22, 23, 25, 11, 12];

function Product() {
  const {
    userId,
    userToken,
    userEmail,
    userName,
    cartToken,
    languageCode,
    countryCode,
    viewedProducts,
    localProducts,
  } = useSelector((state) => state.auth);
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { storeId, id, title } = useParams();
  const variant = new URLSearchParams(location.search).get("variant") || "";

  const country = new URLSearchParams(location.search).get("country") || "";
  const productInfo = useGetProductQuery(
    { id: id, store_id: storeId, countryCode: countryCode, variant: variant, country: country },
    { count: 1 },
    { refetchOnMountOrArgChange: true }
  );
  const productData = productInfo?.data?.product;

  function productTitle(title) {
    const thitilte = title?.split(" ").slice(0, 100).join(" ");
    return thitilte
      ?.replace(/[^A-Za-z0-9]/g, " ")
      ?.replace(/[^\w\s]/gi, " ")
      ?.replace(/ /g, "-");
  }
  // useEffect(() => {
  //   if (!productInfo?.isLoading) {
  //     if (!productInfo?.isFetching) {
  //       if (storIds?.includes(Number(productData?.store_id))) {
  //         if (id !== productData?.pid) {
  //           history.replace(`/product/${productData?.store_id}/${productData?.pid}/${productTitle(productData?.title)}`);
  //         }
  //       }
  //     }
  //   }
  // }, [productData?.pid, id, history])

  const relatedData = useGetRelatedQuery(
    { countryCode: countryCode },
    { count: 1 },
    { refetchOnMountOrArgChange: true }
  );
  const isMobcreen = useMediaQuery({ query: "(min-width: 0px) and (max-width: 992px)" });

  let fontFamilyForAll;
  if (languageCode === "ar") {
    fontFamilyForAll = "GessTwoMedium, sans-serif";
  } else if (languageCode === "urdu") {
    fontFamilyForAll = "AlQalam Shakir";
  } else {
    fontFamilyForAll = "Poppins, sans-serif";
  }
  const fontFamily = {
    fontFamily: fontFamilyForAll,
  };

  function cartButton() {
    if (productData?.inventory && Number(productData?.qty) > 0) {
      if (productInfo?.isLoading) {
        return true;
      } else if (!productData?.prices?.value) {
        return true;
      } else if (Number(productData?.prices?.value) === 0) {
        return true;
      } else if (Number(productData?.prices?.bdp) === 0) {
        return true;
      } else if (productInfo?.isFetching) {
        return true;
      } else {
        return false;
      }
    } else {
      if (productInfo?.isLoading) {
        return true;
      } else if (!productData?.prices?.value) {
        return true;
      } else if (Number(productData?.prices?.value) === 0) {
        return true;
      } else if (Number(productData?.prices?.bdp) === 0) {
        return true;
      } else if (!productData?.in_stock) {
        return true;
      } else if (Number(productData?.quantity) === 0) {
        return true;
      } else if (productInfo?.isFetching) {
        return true;
      } else {
        return false;
      }
    }
  }

  function productNotAvailable() {
    if (productData?.inventory && Number(productData?.qty) > 0) {
      if (!productData?.prices?.value) {
        return true;
      } else if (Number(productData?.prices?.value) === 0) {
        return true;
      } else if (Number(productData?.prices?.bdp) === 0) {
        return true;
      } else {
        return false;
      }
    } else {
      if (!productData?.prices?.value) {
        return true;
      } else if (Number(productData?.prices?.value) === 0) {
        return true;
      } else if (Number(productData?.prices?.bdp) === 0) {
        return true;
      } else if (!productData?.in_stock) {
        return true;
      } else if (Number(productData?.quantity) === 0) {
        return true;
      } else {
        return false;
      }
    }
  }

  function productFetching() {
    if (productInfo?.isLoading) {
      return true;
    } else if (productInfo?.isFetching) {
      return true;
    } else {
      return false;
    }
  }

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: "smooth"
    });
  }, [productInfo]);

  function getProductDetails() {
    return <ProductDetails productData={productData} isLoading={productInfo?.isLoading} id={id} />;
  }

  function getProductFeatures() {
    return (
      <ProductFeatures
        productData={productData}
        productFetching={productFetching()}
        title={title}
        id={id}
        isLoading={productInfo?.isLoading}
        isFetching={productInfo?.isFetching}
        productNotAvailable={productNotAvailable()}
      />
    );
  }

  const [getAlertDialogue, setAlertDialogue] = React.useState(false);

  useEffect(() => {
    if (productData?.inventory) {
      setAlertDialogue(false);
    } else {
      if (!productFetching()) {
        if (!productData) {
          setAlertDialogue(true);
        } else {
          if (productData?.status) {
            setAlertDialogue(true);
          } else {
            setAlertDialogue(false);
          }
        }
      }
      if (productFetching()) {
        setAlertDialogue(false);
      }
    }
  }, [productInfo, productData, id, variant, title]);

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "view_item",
      ecommerce: {
        currency: productData?.prices?.currency,
        value: Number(productData?.prices?.value),
        items: [
          {
            item_id: productData?.id,
            item_name: productData?.title,
            item_brand: productData?.brand,
            item_category: productData?.category,
            price: Number(productData?.prices?.value),
            quantity: productData?.quantity,
          },
        ],
      },
    });
  }, [productInfo, productData, id, variant, title]);

  const productSubstringTitle = title ? title?.substring(0, 80) : productData?.title?.substring(0, 80);

  const productDetails = productData?.details;

  function checkDetails(details) {
    if (details === "<p></p>") {
      return false;
    } else if (!details) {
      return false;
    } else {
      return true;
    }
  }

  const ConvertTextToImages = ({ text }) => {
    const replaceUrlsWithImages = (inputText) => {
      const urlRegex = /(https?:\/\/[^\s]+(?:\.jpg|\.png|\.gif))/g;
      return inputText.replace(
        urlRegex,
        (url) => `<img src="${url}" style="max-width: 100%; height: auto; width: 100%;" />`
      );
    };
    const processedText = replaceUrlsWithImages(text);
    return <div style={{ fontSize: "13px", color: "#38393a" }} dangerouslySetInnerHTML={{ __html: processedText }} />;
  };

  useEffect(() => {
    const getLocalProducts = () => {
      const products = localStorage.getItem("localProducts");
      return products ? JSON.parse(products) : [];
    };
    const addOrReplaceProduct = async (newProduct) => {
      if (newProduct) {
        let products = await getLocalProducts();
        const index = await products?.findIndex((product) => product.id === newProduct.id);
        if (index !== -1) {
          products[index] = newProduct;
        } else {
          await products?.push(newProduct);
        }
        if (products?.length > 10) {
          await products?.shift();
        }
        if (newProduct?.image) {
          dispatch(addLocalProducts({ localProducts: products }));
        }
      }
    };
    const newProduct = {
      id: productData?.id,
      pid: productData?.pid,
      store_id: productData?.store_id,
      title: productData?.title,
      image: productData?.image,
      country: productData?.country,
    };
    addOrReplaceProduct(newProduct);
  }, [productData]);

  const headerTitle = `${productSubstringTitle && productSubstringTitle?.replace(/-/g, " ")?.replace(/[^\w\s.,'/:]/gi, " ")}`;
  const [api, contextHolder] = notification.useNotification();
  React.useEffect(() => {
    if (productInfo?.error?.originalStatus === 429) {
      api["error"]({
        message: productInfo?.error?.data,
        showProgress: true,
        pauseOnHover: false,
        duration: 5,
        placement: "top",
      });
    }
  }, [productInfo]);

  const storeIds = [1, 3, 18, 19, 20, 21, 22, 23, 25, 11, 12];

  function DynamicBreadcrumb({ data }) {
    const handleClick = (event) => {
      event.preventDefault();
      console.info("Breadcrumb clicked");
    };

    if (!data)
      return (
        <div role="presentation" onClick={handleClick}>
          <Breadcrumbs className="pp--breadcrumb" aria-label="breadcrumb">
            <StyledBreadcrumb
              style={{ cursor: "pointer" }}
              component={Link}
              to="/"
              label="Home"
              icon={<HomeIcon style={{ fontSize: "1.1rem" }} fontSize="small" />}
            />
          </Breadcrumbs>
        </div>
      );

    const categories = data?.split(" > ")?.map((cat) => cat.trim());

    return (
      <div role="presentation" onClick={handleClick}>
        <Breadcrumbs className="pp--breadcrumb" aria-label="breadcrumb">
          <StyledBreadcrumb
            style={{ cursor: "pointer" }}
            component={Link}
            to="/"
            label="Home"
            icon={<HomeIcon style={{ fontSize: "1.1rem" }} fontSize="small" />}
          />
          {categories?.map((category, index) => (
            <StyledBreadcrumb
              style={{ cursor: "pointer" }}
              key={index}
              component={Link}
              to={`/search/${category}`}
              label={category}
            />
          ))}
        </Breadcrumbs>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>{`${headerTitle ? headerTitle : ""} ${headerTitle && "|"} ${Host?.metaTitle}`}</title>
      </Helmet>
      {contextHolder}

      <div className="product-page">
        <div className="container purchase-container">
          <div className="row product-section" style={{ position: "relative" }}>
            <div className="col-md-12" style={{ padding: 0, marginBottom: "10px" }}>
              <DynamicBreadcrumb data={productData?.category} />
            </div>

            {getAlertDialogue && (
              <div className="row" style={{ justifyContent: "center" }}>
                <div className="col-md-4" style={{ textAlign: "center" }}>
                  <br />
                  <div className="form-group">
                    <div
                      className="alert alert-secondary"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        textAlign: "start",
                        fontSize: "1rem",
                        fontWeight: 400,
                      }}
                    >
                      <InfoOutlinedIcon style={{ fontSize: "1.5rem" }} />
                      <span style={{ margin: "0px 10px" }}>The product is not available!</span>
                    </div>
                    <div className="col-md-12" style={{ textAlign: "start", padding: 0 }}>
                      <div className="form-group">
                        <Button
                          variant="outlined"
                          style={fontFamily}
                          component={Link}
                          to={`/search/${title?.substring(0, 30)?.replace(/-/g, " ")}`}
                        >
                          <div style={{ textTransform: "capitalize", fontWeight: 400 }}>Search for similar</div>
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {!getAlertDialogue && (
              <>
                <div className="col-md-10 row-col-p" style={{ padding: 0 }}>
                  <div className="row" style={{ justifyContent: "center" }}>
                    <div className="col-md-6 row-col-p" style={{ padding: 0 }}>
                      <div className="product-image-view">
                        <div className="purchase-form-card product-image-main" style={{ position: "relative" }}>
                          <ProductImages
                            productData={productData}
                            isLoading={productInfo?.isLoading}
                            isFetching={productInfo?.isFetching}
                          />
                        </div>
                      </div>
                      {!isMobcreen && <div className="specification-section">{getProductDetails()}</div>}
                    </div>
                    <div className="col-md-6 row-col-p">
                      <div className="purchase-info-card bb">{getProductFeatures()}</div>
                      {isMobcreen && <div className="specification-section">{getProductDetails()}</div>}
                    </div>
                  </div>
                  <div className="row" style={{ justifyContent: "center", marginTop: "15px" }}>
                    <div className="col-md-12 row-col-p" style={{ padding: 0 }}>
                      {productData?.specifications?.length > 0 && <h5 className="cardTitle">{t("specifications")}</h5>}
                      {productData?.specifications && Array.isArray(productData?.specifications) ? (
                        <div
                          className="spec-table-over rrrr"
                          style={
                            isMobcreen
                              ? {}
                              : languageCode == "en"
                                ? {
                                    marginRight: "15px",
                                    border:
                                      productData?.specifications?.length > 0 ? "1px solid rgb(222, 226, 230)" : "none",
                                  }
                                : {
                                    marginLeft: "15px",
                                    border:
                                      productData?.specifications?.length > 0 ? "1px solid rgb(222, 226, 230)" : "none",
                                  }
                          }
                        >
                          <table className="table" style={{ width: "100%", fontSize: "13px" }}>
                            <tbody>
                              {productData?.specifications?.map((item, index) => {
                                const keyName = item.key?.toLowerCase();
                                if (
                                  keyName === "customer reviews" ||
                                  keyName === "asin" ||
                                  keyName === "best sellers rank"
                                )
                                  return null;
                                return (
                                  <>
                                    {storeIds?.includes(Number(productData?.store_id)) ? (
                                      <tr key={index}>
                                        <td style={{ fontWeight: 600, width: "50%", border: "none" }}>
                                          <div
                                            style={{ wordBreak: "auto-phrase" }}
                                            dangerouslySetInnerHTML={{ __html: item.key }}
                                          />
                                        </td>
                                        <td style={{ color: "#6b6b6b", width: "50%", border: "none" }}>
                                          <div
                                            style={{ wordBreak: "auto-phrase" }}
                                            dangerouslySetInnerHTML={{
                                              __html: item.value?.replace(/\(function\(.*?\}\)\);?/s, "").trim(),
                                            }}
                                          />
                                        </td>
                                      </tr>
                                    ) : (
                                      <>
                                        {Object.entries(item || []).map(([key, value], index) => {
                                          const keyName = key?.toLowerCase();
                                          if (
                                            keyName === "customer reviews" ||
                                            keyName === "asin" ||
                                            keyName === "best sellers rank"
                                          )
                                            return null;
                                          return (
                                            <tr key={index}>
                                              <td style={{ fontWeight: 600, width: "50%", border: "none" }}>
                                                <div
                                                  style={{ wordBreak: "auto-phrase" }}
                                                  dangerouslySetInnerHTML={{ __html: key?.toString() }}
                                                />
                                              </td>
                                              <td style={{ color: "#6b6b6b", width: "50%", border: "none" }}>
                                                <div
                                                  style={{ wordBreak: "auto-phrase" }}
                                                  dangerouslySetInnerHTML={{
                                                    __html: value?.replace(/\(function\(.*?\}\)\);?/s, "").trim(),
                                                  }}
                                                />
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      </>
                                    )}
                                  </>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      ) : productData?.specifications && typeof productData?.specifications === "object" ? (
                        <div
                          className="spec-table-over"
                          style={
                            isMobcreen
                              ? {}
                              : languageCode == "en"
                                ? {
                                    marginRight: "15px",
                                    border:
                                      Object.entries(productData?.specifications)?.length > 0
                                        ? "1px solid rgb(222, 226, 230)"
                                        : "none",
                                  }
                                : {
                                    marginLeft: "15px",
                                    border:
                                      Object.entries(productData?.specifications)?.length > 0
                                        ? "1px solid rgb(222, 226, 230)"
                                        : "none",
                                  }
                          }
                        >
                          <table className="table" style={{ width: "100%", fontSize: "13px" }}>
                            <tbody>
                              {Object.entries(productData?.specifications)?.map(([key, value], index) => {
                                const keyName = key?.toLowerCase();
                                if (
                                  keyName === "customer reviews" ||
                                  keyName === "asin" ||
                                  keyName === "best sellers rank"
                                )
                                  return null;
                                return (
                                  <tr key={index}>
                                    <td style={{ fontWeight: 600, width: "50%", border: "none" }}>
                                      <div
                                        style={{ wordBreak: "auto-phrase" }}
                                        dangerouslySetInnerHTML={{ __html: key }}
                                      />
                                    </td>
                                    <td style={{ color: "#6b6b6b", width: "50%", border: "none" }}>
                                      <div
                                        style={{ wordBreak: "auto-phrase" }}
                                        dangerouslySetInnerHTML={{
                                          __html: value?.replace(/\(function\(.*?\}\)\);?/s, "").trim(),
                                        }}
                                      />
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-2 row-col-p" style={{ padding: "0" }}>
                  <AddToCart
                    productData={productData}
                    productFetching={productFetching()}
                    cartButton={cartButton()}
                    isLoading={productInfo?.isLoading}
                    productNotAvailable={productNotAvailable()}
                  />
                </div>
              </>
            )}
          </div>
          <div className="row" style={{ justifyContent: "center" }}>
            <div className="col-md-12" style={{ padding: 0 }}>
              {!productInfo?.isLoading && Number(productData?.store_id) === 9 && (
                <>
                  <h5 className="cardTitle">{t("product_details")}</h5>
                  {checkDetails(productData?.details) && <ConvertTextToImages text={productDetails} />}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {localProducts?.length > 1 && (
        <>
          <div className="hp-style">
            <ViewedProducts relatedData={localProducts} productId={productData?.id} />
          </div>
          <br />
        </>
      )}
      <div className="hp-style">
        <div className="container">
          <HomeProductCards
            productData={relatedData?.data?.related}
            isLoading={relatedData?.isLoading}
            heading={t("you_might_be_interested")}
          />
        </div>
      </div>
    </>
  );
}

export default Product;
